const AplicacaoProvaList = () =>
  import("~/components/Views/Prova/AplicacaoProva/List");
const AplicacaoProvaNew = () =>
  import("~/components/Views/Prova/AplicacaoProva/New");

import auth from "~/middleware/auth";
import grupoVerify from "~/middleware/grupoVerify";
import perfilVerify from "~/middleware/perfilVerify";

const breadcrumb = [
  { name: "Integrado", link: "http://on.grupointegrado.br/" },
  { name: "Prova", link: "/prova" },
  { name: "Gerenciamento", link: "/prova/gerenciamento" }
];

export const aplicacaoProva = [
  {
    path: "gerenciamento/aplicacao-prova",
    component: AplicacaoProvaList,
    name: "Aplicação de Prova",
    meta: {
      middleware: [auth, grupoVerify, perfilVerify],
      breadcrumb
    }
  },
  {
    path: "gerenciamento/aplicacao-prova/new",
    component: AplicacaoProvaNew,
    name: "Nova Aplicação de Prova",
    meta: {
      middleware: [auth, grupoVerify, perfilVerify],
      breadcrumb
    }
  },
  {
    path: "gerenciamento/aplicacao-prova/:id",
    component: AplicacaoProvaNew,
    name: "Alterar Aplicação de Prova",
    meta: {
      middleware: [auth, grupoVerify, perfilVerify],
      breadcrumb
    }
  }
];



// WEBPACK FOOTER //
// ./src/routes/prova/gerenciamento/aplicacaoProva.js